import Vue from 'vue'
import Vuetify from 'vuetify'

import 'vuetify/dist/vuetify.min.css'
Vue.use(Vuetify, {
  theme: {
    themes: {
      light: {
        primary: '#607d8b',
        secondary: '#2d2f3e',
        accent: '#ff5722',
        error: '#ff6666',
        warning: '#ffeb3b',
        info: '#2196f3',
        success: '#1BC470'
      },
    }
  }
})
